export const tr = {
    all: 'Hepsi',
    'all-interest': 'Tüm dönemler için ilgi alanları',
    audience: 'Hedef kitle',
    'audience-and-metrika': 'Yandex.Audience ve Yandex.Metrica',
    'audience-description':
        'Kullanıcıların ilgi alanları, gelir seviyeleri, medeni durumları ve bulundukları konum gibi farklı kriterleri birleştirebilirsiniz.',
    'audience-name': 'Hedef kitle adı',
    'condition-rules-group-preview': {
        one: '{count} kural dizisi',
        some: '{count} kural dizisi',
        many: '{count} kural dizisi',
        none: '{count} kural dizisi'
    },
    'condition-rules-rule-preview': {
        one: '{count} kural',
        some: '{count} kural',
        many: '{count} kural',
        none: '{count} kural'
    },
    'description-by-day': {
        one: '{description} ({count} günde)',
        some: '{description} ({count} günde)',
        many: '{description} ({count} günde)',
        none: '{description} ({count} günde)'
    },
    'interests-set': 'Ilgil alanı seti',
    isNotSet: 'Belirtilmedi',
    'long-term-interest': 'Uzun vadeli ilgi alanları',
    long_term: 'Uzun vadeli',
    'no-value-description': 'Belirlenmedi',
    'short-term-interest': 'Kısa vadeli ilgi alanları',
    short_term: 'Kısa vadeli',
    'unavailable-goal': 'Hedef bulunamadı',
    'user-profile': 'Kullanıcı profili',
    'user-profile-interests-description':
        'Reklamları yalnızca ilgilenen kullanıcılara göstermek için 3 adet kısa vadeli kullanıcı ilgi seti ekleyebilirsiniz',
    'user-profile-name': 'Profil adı',
    'user-profile-no-value-description': 'Belirtilmedi'
};
